import axios from 'axios';
import storage from 'store';
import i18n from '@/i18n';
import store from '../store';

axios.defaults.baseURL = process.env.VUE_APP_API_URL;

const TOKEN_EXPIRED_MESSAGE = 'Error verifying token : jwt expired';

axios.interceptors.request.use(
  (config) => {
    const token =
      config.url === '/users/refresh'
        ? storage.get('refreshToken')
        : storage.get('authToken');
    store.dispatch('setIsLoading', true);
    if (token) {
      return {
        ...config,
        headers: {
          ...config.headers,
          Authorization: `Bearer ${token}`,
          'Accept-Language': i18n.locale,
        },
      };
    }
    return config;
  },
  (error) => {
    throw error;
  }
);

// Deserialize errors for requests with responseType='blob', so that
// error.response.data is defined and refresh token interceptor can always work
// https://github.com/axios/axios/issues/815#issuecomment-453963910
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;
    if (
      error.request &&
      error.request.responseType === 'blob' &&
      response.data instanceof Blob &&
      response.data.type &&
      response.data.type.toLowerCase().indexOf('json') !== -1
    ) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          response.data = JSON.parse(reader.result);
          resolve(Promise.reject(error));
        };
        reader.onerror = () => {
          reject(error);
        };
        reader.readAsText(error.response.data);
      });
    }
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    store.dispatch('setIsLoading', false);
    const { token: authToken, refreshToken } = response.data || {};
    if (authToken && refreshToken) {
      storage.set('authToken', authToken);
      storage.set('refreshToken', refreshToken);
    }
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    // const lab = store.getters.userLab;

    // If no response (e.g., aborted request, network error), just throw the error
    if (!error.response) {
      throw error;
    }

    if (
      error.response.status === 401 &&
      error.response.data.error.message === TOKEN_EXPIRED_MESSAGE &&
      originalRequest.url !== '/users/refresh'
    ) {
      const refreshResponse = await axios.post('/users/refresh');
      if (refreshResponse.status === 200) return axios(originalRequest);
    } else if (
      error.response.status === 401 &&
      originalRequest.url === '/users/refresh'
    ) {
      store.dispatch('setLoggedUser', null);
    }
    throw error;
  }
);

export default axios;
